/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShopOnSitePrintItemQuantity } from './shopOnSitePrintItemQuantity';


export interface ShopOnSitePrintLineDto { 
    orderId?: string | null;
    customerName?: string | null;
    items?: Array<ShopOnSitePrintItemQuantity> | null;
    deliveryDate?: string | null;
    deliveryTime?: string | null;
    deliveryPlace?: string | null;
    shopName?: string | null;
    serviceTypeName?: string | null;
    notes?: string | null;
}

